import React, { Component } from 'react';
import PropTypes from 'prop-types';

class OrderAttributes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      order: {
        id: undefined,
        orderNumber: undefined,
        comments: undefined,
        customerName: undefined,
        tailNumber: undefined,
        location: undefined,
        expectedFulfillDate: undefined,
        towOrder: {
          towOrder: 0,
          orderId: undefined,
          type: undefined,
        },
        oilOrder: {
          oilOrderId: 0,
          orderId: undefined,
          oilTypeId: undefined,
          quantity: undefined,
          oilType: {}
        },
        fuelOrders: [],
      },
      meter: {
        id: undefined,
        name: undefined
      },
      truck: {
        id: undefined,
        name: undefined
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.order) {
      this.setState({ order: nextProps.order });
    }
    if (nextProps.fuelMeter) {
      this.setState({ meter: nextProps.fuelMeter })
    }
    if (nextProps.fuelTruck) {
      this.setState({ truck: nextProps.fuelTruck })
    }
  }

  renderFuelRequests(request) {
    return (
      <span>
        Requests
        {request.orders.map((fuelOrder, i) => (
          <span>
            {fuelOrder.type !== 'none' &&
              <p>
                {fuelOrder.location} {fuelOrder.position}: &nbsp;
                {fuelOrder.type === 'gal' &&
                  <span>{fuelOrder.quantity}&nbsp;</span>
                }
                {fuelOrder.type}
              </p>
            }
          </span>))}
      </span>
    );
  };

  render() {
    const orderString = this.state.order.orderNumber ? `#${this.state.order.orderNumber}` : '';
    const order = this.state.order;
    const fuelOrder = order.fuelOrders[0];

    return (
      <span>

        <div className="create-form page-content-items">
          <article className="order-details">
            <div className="toggle-wrapper">
              <h4 className="order-title-id toggle-title">Order {orderString}</h4>
              <div className="toggle-content">
                <div className="column-one-third">
                  <p>
                    <strong>Customer Name:</strong> {order.customerName}
                  </p>
                </div>
                <div className="column-one-third">
                  <p>
                    <strong>Tail Number:</strong> {order.tailNumber}
                  </p>
                </div>
                <div className="column-one-third">
                  <p>
                    <strong>Plane Location:</strong> {order.location}
                  </p>
                </div>
                <p>
                  <strong>Expected Fulfill Date:</strong> {order.expectedFulfillDate}
                </p>
                {fuelOrder &&
                  <span>
                    <span>
                      <div className="column-one-third">
                        <p>
                          <strong>Fuel Type:</strong> {fuelOrder.fuelType.name}
                        </p>
                      </div>
                      {this.state.truck.name &&
                      <div className="column-one-third">
                        <p>
                          <strong>Fuel Truck:</strong> {this.state.truck.name}
                        </p>
                      </div>
                      }
                      {this.state.meter.name &&
                      <div className="column-one-third">
                        <p>
                          <strong>Fuel Meter:</strong> {this.state.meter.name}
                        </p>
                      </div>
                      }
                    </span>
                    <div className="clear" />
                    <div className="fuel-order-request">
                      {this.renderFuelRequests(fuelOrder.request)}
                    </div>
                  </span>
                }
                {order.oilOrder &&
                  <span>
                    <p>
                      <strong>Oil Type:</strong> {order.oilOrder.oilType.name}
                    </p>
                    <p>
                      quantity: {order.oilOrder.quantity} quarts
                    </p>
                  </span>
                }
                {order.towType &&
                  <p>
                    <strong>TowOrder:</strong> {order.towType}
                  </p>
                }
                <p>
                  <strong>Order Notes:</strong> {order.comments}
                </p>
              </div>
            </div>
          </article>

        </div>
      </span>
    );
  }
}


OrderAttributes.propTypes = {
  order: PropTypes.shape({}).isRequired,
  meter: PropTypes.shape({}),
  truck: PropTypes.shape({}),
};
export default OrderAttributes;




// WEBPACK FOOTER //
// ./src/Containers/Orders/OrderAttributes.js